import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';
import { history } from '@commons';

import { deletePragaDoenca } from '../service';
import {
  DELETE_PRAGA_DOENCA,
  DELETE_PRAGA_DOENCA_PENDING,
  DELETE_PRAGA_DOENCA_SUCCESS,
  DELETE_PRAGA_DOENCA_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast';

function* sagaDeletePragaDoenca(action) {
  yield put({ type: DELETE_PRAGA_DOENCA_PENDING, id: action.id })

  try {
    const result = yield call(deletePragaDoenca, action.id)

    if (result.status !== 204) {
      throw new Error('API delete request failed');
    }

    yield put({ type: DELETE_PRAGA_DOENCA_SUCCESS, id: action.id })

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PRAGA_DOENCA_FAILURE })
    AlertError('Falha ao excluir o registro! Tente novamente...');
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchDeletePragaDoenca() {
  yield takeLatest(DELETE_PRAGA_DOENCA, sagaDeletePragaDoenca)
}